/**
 * SelectThemed
 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { v4 as uuid } from 'uuid';

const useStyles = makeStyles(() => ({
  rowOption: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

/**
 * SelectThemed
 *
 * @param title {string} : string
 * @returns {JSX.Element}
 */
function SelectThemed({
  dirty,
  invalid,
  selected,
  errorText,
  formik,
  items,
  required,
  title,
  name,
  style,
}) {
  const classes = useStyles();
  const getFieldClasses = () => {
    const fieldClasses = [
      'mdl-textfield',
      'mdl-js-textfield',
    ];

    if (!selected) {
      fieldClasses.push('mdl-textfield--floating-label');
    }

    if (dirty) {
      fieldClasses.push('is-dirty');
    }

    if (invalid) {
      fieldClasses.push(classes.isInvalid);
    }

    return fieldClasses.join(' ');
  };
  return (
    <div
      className={getFieldClasses('province', true)}
      style={style}
    >
      <select
        id={name}
        name={name}
        className="ga-select"
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      >
        <option value="">{`${title} ${required ? '*' : ''}`}</option>
        {items.map((item) => (
          <option
            value={item.value}
            key={uuid()}
            className={classes.rowOption}
          >
            {item.text}
          </option>
        ))}
      </select>
      <span className="mdl-textfield__error">{errorText}</span>
    </div>
  );
}

SelectThemed.propTypes = {
  dirty: PropTypes.bool,
  invalid: PropTypes.bool,
  selected: PropTypes.bool,
  errorText: PropTypes.string,
  title: PropTypes.string.isRequired,
  formik: PropTypes.shape({
    initialValues: PropTypes.shape({}),
    values: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    touched: PropTypes.shape({}),
    validateField: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    setTouched: PropTypes.func.isRequired,
    validateForm: PropTypes.func.isRequired,
    setErrors: PropTypes.func.isRequired,
    debounceTime: PropTypes.number,
    validateOnChange: PropTypes.bool,
    validateOnBlur: PropTypes.bool,
  }).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    text: PropTypes.string,
  })),
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
};
SelectThemed.defaultProps = {
  dirty: false,
  selected: false,
  invalid: false,
  errorText: '',
  items: [],
  required: false,
  style: {},
};
export default SelectThemed;
